Number.isInteger=Number.isInteger||function(e){return"number"==typeof e&&isFinite(e)&&Math.floor(e)===e};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mdn-polyfills/Number.isInteger.js
// module id = 318y
// module chunks = 20